import Vue from "vue";
import VueGtm from "vue-gtm";
import { createProvider } from "@/lib/apollo/apollo";

// Import our components here to preserve CSS load order
import "@/config/components";
import "@/config/apm";
import "@/config/plugins";
import "@/config/filters";
import "@/config/directives";
import "@/config/misc";

import App from "@/App.vue";
import router from "@/router";
import { isLocal } from "@/utils/constants";

// Styles
import "@/assets/css/tailwind.css";

// Tracking
Vue.use(VueGtm, {
  id: "GTM-W9V7L5T", // Your GTM ID
  // enabled: !isLocal, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  // debug: isLocal, // Whether or not display console logs debugs (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: ["Unsubscribe"], // If router, you can exclude some routes name (case insensitive) (optional)
});

new Vue({
  router,
  // apolloProvider,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount("#app");

// Clear the console if we're hot reloading...
if (isLocal && module.hot) {
  module.hot.accept(); // already had this init code

  module.hot.addStatusHandler((status) => {
    if (status === "prepare") console.clear();
  });
}
